import { thi_date } from "../../../services/Helper";
import logo from "./../../../assets/thi-logo.jpg";
import QRCode from "qrcode";
import { useState, useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import config from "./../../../config.json";

const TestHeader = ({ header, print, pid, printRef }) => {
  const [QRCodeData, setQRCode] = useState([]);
  const componentRef = useRef();

  const logo_w = 100;
  const generateQR = async (text) => {
    try {
      // console.log(await QRCode.toDataURL(text));
      setQRCode(await QRCode.toDataURL(text));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const qrinfo = `http://tahirheart.org/report/all/${pid}/${header.TESTID}`;
    generateQR(qrinfo);
  }, [header, pid]);

  console.log(header);

  const handlePrint = () => {
    window.print();
  };

  const getTitle = () => {
    const husbandName = header.HUSBANDNAME || "";
    const fatherName = header.FATHERSNAME || "";

    if (husbandName) {
      return `${header.NAME} W/O ${husbandName}`;
    } else if (fatherName) {
      const relation = header.GENDER === "M" ? "S/O" : "D/O";
      return `${header.NAME} ${relation} ${fatherName}`;
    }
    return header.NAME;
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          marginBottom: "1rem",
          gap: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexShrink: 0,
            minWidth: "fit-content",
          }}
        >
          <img src="/logo.jpeg" alt="FOH LAB" width={logo_w} />
          <div style={{ whiteSpace: "nowrap" }}>
            <h5 className="fw-bold mb-0" style={{ color: "#0d6efd" }}>
              FOH LAB
            </h5>
            <div
              style={{ fontSize: "9px", color: "#6c757d", lineHeight: "1.4" }}
            >
              <div>Fazle Omar Hospital Rabwah</div>
              <div>
                Phone: (047) 6215646/6213970 | Email: info@fohrabwah.org
              </div>
            </div>
          </div>
        </div>
        <div style={{ fontSize: "11px", minWidth: "150px" }}>
          <div>
            <strong>Patient:</strong> {getTitle()}
          </div>
          <div>
            <strong>Patient ID:</strong> {pid}
          </div>
          <div>
            <strong>DOB:</strong>{" "}
            {header.DOBIRTH ? thi_date(header.DOBIRTH) : "N/A"}
          </div>
        </div>
        <div style={{ fontSize: "11px", minWidth: "150px" }}>
          <div>
            <strong>Test ID:</strong> {header.TESTID}
          </div>
          <div>
            <strong>Date:</strong> {thi_date(header.DOTEST)}
          </div>
          <div>
            <strong>Time:</strong> {header.TOTEST}
          </div>
        </div>
        <img
          src={QRCodeData}
          alt="QRCode"
          width={logo_w}
          style={{ flexShrink: 0 }}
        />
      </div>
    </>
  );
};

export default TestHeader;
